<div class="flex flex-col justify-center items-center min-h-screen bg-background">
  <div class="flex bg-white shadow-lg rounded-2xl overflow-hidden max-w-md w-full">
    <div class="flex flex-col w-full px-8 py-10 text-center gap-8">
      <div class="flex flex-col justify-between gap-3">
        <img [src]="branding.LOGO" [alt]="branding.APP_NAME" class="h-8 mx-auto" />
        <h1 class="text-2xl font-bold text-primary-dark">Redefinir a senha</h1>
        <p class="font-normal text-primary-gray">
          Informe a nova senha que deseja utilizar.
        </p>
      </div>

      <form [formGroup]="redefinirSenhaForm" (ngSubmit)="onSubmit()">
        <div class="mb-4 text-left">
          <label for="novaSenha" class="input-label">
            Nova Senha
          </label>
          <div class="input-field"
            [ngClass]="{'input-field-error': redefinirSenhaForm.get('novaSenha')?.invalid && !novaSenhaFocused && redefinirSenhaForm.get('novaSenha')?.touched && redefinirSenhaForm.get('novaSenha')?.value, 'input-field-focus': !(redefinirSenhaForm.get('novaSenha')?.invalid && !novaSenhaFocused && redefinirSenhaForm.get('novaSenha')?.touched && redefinirSenhaForm.get('novaSenha')?.value)}">
            <mat-icon fontSet="material-icons-outlined" class="text-gray-500 small-icon">lock</mat-icon>
            <input id="novaSenha" [type]="passwordVisible ? 'text' : 'password'" formControlName="novaSenha"
              placeholder="Insira sua nova senha" class="input-element py-3" (focus)="novaSenhaFocused = true"
              (blur)="novaSenhaFocused = false" />
            <button type="button" class="button-standard button-color-primary" (mousedown)="$event.preventDefault();"
              (click)="this.passwordVisible = !this.passwordVisible" class="px-2 focus:outline-none">
              <mat-icon fontSet="material-icons-outlined" class="text-gray-500 small-icon">{{ passwordVisible ? 'visibility_off' : 'visibility'
                }}</mat-icon>
            </button>
          </div>
          <div
            *ngIf="redefinirSenhaForm.get('novaSenha')?.invalid && !novaSenhaFocused && redefinirSenhaForm.get('novaSenha')?.touched && redefinirSenhaForm.get('novaSenha')?.value"
            class="text-red-500 text-sm mt-1">
            <div *ngIf="redefinirSenhaForm.get('novaSenha')?.errors?.['required']">
              Senha é obrigatória.
            </div>
            <div *ngIf="redefinirSenhaForm.get('novaSenha')?.errors?.['minlength']">
              Senha deve ter pelo menos 8 caracteres.</div>
            <div *ngIf="redefinirSenhaForm.get('novaSenha')?.errors?.['pattern']">
              Senha deve conter letras maiúsculas, minúsculas e caracteres especiais.
            </div>
          </div>
        </div>
        <div class="mb-4 text-left">
          <label for="confirmeSenha" class="input-label">
            Confirme a senha
          </label>
          <div class="input-field"
            [ngClass]="{'input-field-error': redefinirSenhaForm.get('confirmeSenha')?.invalid && !confirmeSenhaFocused && redefinirSenhaForm.get('confirmeSenha')?.touched && redefinirSenhaForm.get('confirmeSenha')?.value, 'input-field-focus': !(redefinirSenhaForm.get('confirmeSenha')?.invalid && !confirmeSenhaFocused && redefinirSenhaForm.get('confirmeSenha')?.touched && redefinirSenhaForm.get('confirmeSenha')?.value)}">
            <mat-icon fontSet="material-icons-outlined" class="text-gray-500 small-icon">lock</mat-icon>
            <input id="confirmeSenha" [type]="confirmationPasswordVisible ? 'text' : 'password'"
              formControlName="confirmeSenha" placeholder="Repita a senha" class="input-element py-3"
              (focus)="confirmeSenhaFocused = true" (blur)="confirmeSenhaFocused = false" />
            <button type="button" class="button-standard button-color-primary"
              (click)="this.confirmationPasswordVisible = !this.confirmationPasswordVisible"
              class="px-2 focus:outline-none">
              <mat-icon fontSet="material-icons-outlined" class="text-gray-500 small-icon">
                {{ confirmationPasswordVisible ? 'visibility_off' : 'visibility' }}
              </mat-icon>
            </button>
          </div>
          <div
            *ngIf="redefinirSenhaForm.get('confirmeSenha')?.invalid && !confirmeSenhaFocused && redefinirSenhaForm.get('confirmeSenha')?.touched && redefinirSenhaForm.get('confirmeSenha')?.value"
            class="text-red-500 text-sm mt-1">
            <div *ngIf="redefinirSenhaForm.get('confirmeSenha')?.errors?.['required']">
              Confirmação de senha é obrigatória.
            </div>
            <div *ngIf="redefinirSenhaForm.get('confirmeSenha')?.errors?.['mismatch']">
              As senhas não coincidem.
            </div>
          </div>
        </div>
        <button type="submit" class="button-compact button-color-primary flex items-center justify-center w-full"
          [ngClass]="{'button-disabled': redefinirSenhaForm.invalid}" [disabled]="redefinirSenhaForm.invalid">
          Salvar nova senha
        </button>
        <div class="flex justify-center">
          <a class="text-sm font-medium text-primary hover:underline mt-5" (click)="navigateToLogin()">
            Voltar ao Login
          </a>
        </div>
      </form>
    </div>
  </div>
</div>
